import React from 'react';
import { Form } from 'semantic-ui-react';

import { Resultados } from 'src/api';

import moment from 'moment';
import { SelectDeAlumnos, SelectDeCursos } from 'src/componentes';
import { SegmentConLoader } from './SegmentConLoader';

type Cursos = Readonly<Resultados<'listaDeCursos'>['cursos']>;

export type Registro = Readonly<{
    idAlumno: string;
    fecha: string;
    idCursoDeDestino: number;
}>;

export type Props = Readonly<{
    cargando: boolean;
    alumnos: ReadonlyArray<{
        id: string;
        nombre: string;
    }>;
    cursos: Cursos;
    fechaMinima: string;
    fechaMaxima: string;
    fechaInicial: string;
    alIngresar: (datos: Registro) => Promise<boolean>;
}>;

type State = Readonly<{
    idAlumno: string;
    fecha: string;
    idCursoDeDestino: number | '';
    ingresando: boolean;
    cursosFiltrados: Cursos;
}>;

export class IngresoRecuperacion extends React.Component<Props, State> {
    public readonly state: State = {
        ingresando: false,
        idAlumno: '',
        fecha: this.props.fechaInicial,
        idCursoDeDestino: 0,
        cursosFiltrados: [],
    };

    public componentDidMount() {
        this.elegirFecha(this.props.fechaInicial);
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.cursos !== this.props.cursos) {
            this.setState({
                cursosFiltrados: this.cursosQueCoincidenConLaFecha(this.props.fechaInicial),
            });
        }
    }

    public render() {
        const { cargando, alumnos, fechaMinima, fechaMaxima } = this.props;
        const { ingresando, idAlumno, fecha, idCursoDeDestino, cursosFiltrados } = this.state;

        return (
            <SegmentConLoader cargando={cargando}>
                <Form
                    onSubmit={() => {
                        this.setState({ ingresando: true });
                        this.props
                            .alIngresar({
                                idAlumno: this.state.idAlumno,
                                fecha: this.state.fecha,
                                idCursoDeDestino: this.state.idCursoDeDestino as number,
                            })
                            .then(ingresadoCorrectamente => {
                                this.setState({ ingresando: false });
                                if (ingresadoCorrectamente) {
                                    this.setState({
                                        idAlumno: '',
                                        idCursoDeDestino: 0,
                                    });
                                    this.elegirFecha(this.props.fechaInicial);
                                }
                            })
                            .catch();
                    }}
                >
                    <Form.Group>
                        <SelectDeAlumnos
                            alumnos={alumnos}
                            idAlumnoSeleccionado={idAlumno}
                            alSeleccionarAlumno={this.seleccionarAlumno}
                            width='7'
                        />

                        <Form.Input
                            label='Fecha en que asistirá'
                            required
                            type='date'
                            min={fechaMinima}
                            max={fechaMaxima}
                            value={fecha}
                            onChange={(_, { value }) => this.elegirFecha(value)}
                            onBlur={({ target }: React.FocusEvent<HTMLInputElement>) => {
                                if (target.value < target.min || target.value > target.max) {
                                    this.setState({ fecha: '' });
                                }
                            }}
                            width='3'
                        />

                        {cursosFiltrados.length > 0 ? (
                            <SelectDeCursos
                                label='Curso'
                                cursos={cursosFiltrados}
                                idCursoSeleccionado={idCursoDeDestino as number}
                                alSeleccionarCurso={this.seleccionarCursoDeDestino}
                            />
                        ) : (
                            <Form.Field>
                                <label>Curso</label>
                                <p>No hay cursos en la fecha elegida.</p>
                            </Form.Field>
                        )}
                    </Form.Group>

                    <Form.Button
                        primary
                        content='Agendar recuperación'
                        loading={ingresando}
                        disabled={!idAlumno || !fecha || !idCursoDeDestino}
                        type='submit'
                    />
                </Form>
            </SegmentConLoader>
        );
    }

    private cursosQueCoincidenConLaFecha(fecha: string) {
        const diaDeLaFecha = moment(fecha).day();

        return this.props.cursos.filter(curso => curso.dia === diaDeLaFecha);
    }

    private readonly elegirFecha = (fecha: string) => {
        this.setState({
            fecha,
            cursosFiltrados: this.cursosQueCoincidenConLaFecha(fecha),
            idCursoDeDestino: '',
        });
    };

    private readonly seleccionarAlumno = (idAlumno: string) => {
        this.setState({ idAlumno });
    };

    private readonly seleccionarCursoDeDestino = (idCursoDeDestino: number) => {
        this.setState({ idCursoDeDestino });
    };
}



// WEBPACK FOOTER //
// ./src/modulos/Recuperaciones/IngresoRecuperacion.tsx